module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_9016.dedfb661.png";